import { render } from "./AdminEditTicket.vue?vue&type=template&id=128657ea&scoped=true"
import script from "./AdminEditTicket.vue?vue&type=script&lang=js"
export * from "./AdminEditTicket.vue?vue&type=script&lang=js"

import "./AdminEditTicket.vue?vue&type=style&index=0&id=128657ea&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128657ea"]])

export default __exports__